export default __webpack_public_path__ + "609dea61c685bb428ed234a82709b37e.png";